import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Fields, reduxForm } from 'redux-form';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Button } from 'react-bootstrap';
import { TextInput, FormErrorMessages, PasswordRulesHint } from 'ecs-react-components/dist/index.es';
import { messages } from './UpdatePasswordForm.i18n';


export const fields = ['oldPwd', 'newPwd', 'confirmNewPwd'];

class UpdatePasswordForm extends Component {
  onUpdatePasswordClick = (values) => {
    const { userName } = this.props;
    const { oldPwd, newPwd, confirmNewPwd } = values;
    this.props.handleUpdatePassword(userName, oldPwd, newPwd, confirmNewPwd);
  };

  getOldPwdTextInputRef = (c) => { this.oldPwdTextInputRef = c; };
  getNewPwdTextInputRef = (c) => { this.newPwdTextInputRef = c; };
  getConfirmNewPwdTextInputRef = (c) => { this.confirmNewPwdTextInputRef = c; };

  renderFields = (fieldsMeta) => {
    const { oldPwd, newPwd, confirmNewPwd, pwdRules, error } = fieldsMeta;
    const getLabel = (f) => f + 'Label';
    if (error) {
      oldPwd.meta.invalid = true;
    }
    return (
      <div>
        <label id={getLabel(oldPwd.input.name)} htmlFor={oldPwd.input.name} data-qa-item="oldPasswordLbl">
          <FormattedMessage {...messages.label.old} />
          <FormErrorMessages field={oldPwd}
            ariaDescribedby={getLabel(oldPwd.input.name)}
            customMessage={<FormattedMessage {...messages.error.oldPassword} />}
          />
        </label>
        <TextInput
          ref={this.getOldPwdTextInputRef}
          type="password"
          field={ oldPwd }
          data-qa-item="oldPasswordInput"
        />
        <div className="spacer small" />
        <label id={getLabel(newPwd.input.name)} htmlFor={newPwd.input.name} data-qa-item="newPasswordLbl">
          <FormattedMessage {...messages.label.new} />
          <FormErrorMessages field={newPwd}
            ariaDescribedby={getLabel(newPwd.input.name)}
            customMessage={<FormattedMessage {...messages.error.rules} />}
          />
        </label>
        <TextInput
          ref={this.getNewPwdTextInputRef}
          type="password"
          field={ newPwd }
          data-qa-item="newPasswordInput"
        >
          <span className="understated small" id="ruleHint">
            <PasswordRulesHint rules={pwdRules} intl={this.props.intl}/>
          </span>
        </TextInput>
        <div className="spacer small" />
        <label id={getLabel(confirmNewPwd.input.name)}
          htmlFor={confirmNewPwd.input.name}
          data-qa-item="confirmNewPasswordLbl"
        >
          <FormattedMessage {...messages.label.confirmNew} />
          <FormErrorMessages field={confirmNewPwd}
            ariaDescribedby={getLabel(confirmNewPwd.input.name)}
          />
        </label>
        <TextInput
          ref={this.getConfirmNewPwdTextInputRef}
          type="password"
          field={ confirmNewPwd }
          data-qa-item="confirmNewPasswordInput"
        />
      </div>
    );
  }

  render() {
    const { handleSubmit, pwdRules, error } = this.props;
    const submitLabel = <FormattedMessage {...messages.updatePassword.label} />;
    return (
      <div className="col-md-6 col-sm-12 col-md-offset-3">
        <div className="panel panel-default description-box reset notheme">
          <div className="panel-body">
            <div className="content-area">
              <form onSubmit={handleSubmit(this.onUpdatePasswordClick)}>
                <p data-qa-item="updatePasswordIntro">
                  <FormattedMessage {...messages.intro.label} />
                </p>
                <div className="spacer small" />
                <Fields names={fields}
                  component={this.renderFields}
                  pwdRules={pwdRules}
                  error={error}
                />
                <div className="spacer small" />
                <div className="button-area">
                  <Button
                    bsClass="btn btn_lg btn-primary"
                    type="submit"
                    onClick={handleSubmit(this.onUpdatePasswordClick)}
                    data-qa-item="logInButton"
                  >
                    { submitLabel }
                  </Button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

UpdatePasswordForm.propTypes = {
  handleUpdatePassword: PropTypes.func.isRequired,
  fields: PropTypes.array.isRequired,
  values: PropTypes.object,
  userName: PropTypes.string,
  pwdRules: PropTypes.object,
  handleSubmit: PropTypes.func,
  error: PropTypes.object,
  intl: PropTypes.object,
};

const reduxFormConfig = {
  form: 'updatepasswordform',
  fields,
};

export default reduxForm(reduxFormConfig)(injectIntl(UpdatePasswordForm));